module.exports = __webpack_public_path__ + "static/media/kumar.b9167c69.jpg";